'use client';

import { c as _c } from "react/compiler-runtime";
import useModalStore from '@module/stores/useModalStore';
import { useEffect } from 'react';
import { bannerExpiresSafeLocalStorage } from '../../lib/storage/storageImplementations';
import { useFetchMobileMainInfo, useFetchWebMainPageQuery } from '../../queries/main/mainQueryHooks';
import { checkIsMobile } from '../../utils/checkIsMobile';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';
const SEARCH_REFERRERS = ['google.com', 'search.naver.com'] as const;
const useBannerViewModel = () => {
  const $ = _c(17);
  const {
    pushModal,
    popModal
  } = useModalStore();
  const {
    siteMode,
    isLogin,
    isFetched: isLoginInfoFetched
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = checkIsMobile();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isMobile = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    t2 = {
      enabled: !isMobile
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const {
    data: PcMainInfo
  } = useFetchWebMainPageQuery(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    t4 = {
      enabled: isMobile
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const {
    data: MobileMainInfo
  } = useFetchMobileMainInfo(t3, t4);
  let t5;
  if ($[5] !== MobileMainInfo || $[6] !== PcMainInfo || $[7] !== isLogin || $[8] !== isLoginInfoFetched || $[9] !== popModal || $[10] !== pushModal || $[11] !== siteMode?.mode) {
    t5 = () => {
      if (!isLoginInfoFetched) {
        return;
      }
      const bannerExpires = bannerExpiresSafeLocalStorage.get();
      const now = new Date();
      const {
        href
      } = window.location;
      if (href.includes("#join")) {
        return;
      }
      const isSearchReferrer = SEARCH_REFERRERS.some(_temp);
      if (isSearchReferrer) {
        return;
      }
      if (siteMode?.mode === "v" && !isLogin) {
        return;
      }
      if (bannerExpires && new Date(bannerExpires) > now) {
        return;
      }
      if (isMobile) {
        if (!MobileMainInfo?.banner) {
          return;
        }
        if (MobileMainInfo.banner.length === 0) {
          return;
        }
        pushModal({
          type: "BANNER_MODAL",
          id: "useBannerViewModel",
          options: {
            bannerList: MobileMainInfo.banner
          },
          onClickOutside: popModal
        });
      } else {
        if (!PcMainInfo?.banner) {
          return;
        }
        if (PcMainInfo.banner.length === 0) {
          return;
        }
        pushModal({
          type: "BANNER_MODAL",
          id: "useBannerViewModel",
          options: {
            bannerList: PcMainInfo.banner
          },
          onClickOutside: popModal
        });
      }
    };
    $[5] = MobileMainInfo;
    $[6] = PcMainInfo;
    $[7] = isLogin;
    $[8] = isLoginInfoFetched;
    $[9] = popModal;
    $[10] = pushModal;
    $[11] = siteMode?.mode;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = PcMainInfo?.banner;
  const t7 = MobileMainInfo?.banner;
  let t8;
  if ($[13] !== isLoginInfoFetched || $[14] !== t6 || $[15] !== t7) {
    t8 = [t6, t7, isLoginInfoFetched];
    $[13] = isLoginInfoFetched;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  useEffect(t5, t8);
};
export default useBannerViewModel;
function _temp(domain) {
  return document.referrer.includes(domain);
}